module.exports = __webpack_public_path__ + "img/home_header.c2782d40.jpg";